var map = {
	"./InfectionRisk.svg": 236,
	"./activity.svg": 231,
	"./acuityB.svg": 232,
	"./ambulant.svg": 233,
	"./cardiacMonitoring.svg": 234,
	"./infection.svg": 235,
	"./ivInfusionIcon.svg": 237,
	"./medication.svg": 238,
	"./memoryLossIcon.svg": 239,
	"./mentalHealth.svg": 240,
	"./nilByMouthIcon.svg": 241,
	"./nonambulant.svg": 242,
	"./o2DeliveryIcon.svg": 243,
	"./patientDisplaysAggression.svg": 207,
	"./potentially.svg": 458,
	"./prescribedMedication.svg": 244,
	"./sedated.svg": 245,
	"./translator.svg": 246
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 729;